/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConfigurationDto } from './ConfigurationDto';
import {
    ConfigurationDtoFromJSON,
    ConfigurationDtoFromJSONTyped,
    ConfigurationDtoToJSON,
    ConfigurationDtoToJSONTyped,
} from './ConfigurationDto';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * 
 * @export
 * @interface ConfigurationListResponse
 */
export interface ConfigurationListResponse {
    /**
     * 
     * @type {Array<ConfigurationDto>}
     * @memberof ConfigurationListResponse
     */
    data?: Array<ConfigurationDto>;
    /**
     * 
     * @type {string}
     * @memberof ConfigurationListResponse
     */
    userTimezone?: string;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof ConfigurationListResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof ConfigurationListResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof ConfigurationListResponse
     */
    timezoneMetadata?: TimezoneMetadata;
}

/**
 * Check if a given object implements the ConfigurationListResponse interface.
 */
export function instanceOfConfigurationListResponse(value: object): value is ConfigurationListResponse {
    return true;
}

export function ConfigurationListResponseFromJSON(json: any): ConfigurationListResponse {
    return ConfigurationListResponseFromJSONTyped(json, false);
}

export function ConfigurationListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigurationListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(ConfigurationDtoFromJSON)),
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
    };
}

export function ConfigurationListResponseToJSON(json: any): ConfigurationListResponse {
    return ConfigurationListResponseToJSONTyped(json, false);
}

export function ConfigurationListResponseToJSONTyped(value?: ConfigurationListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(ConfigurationDtoToJSON)),
        'userTimezone': value['userTimezone'],
        'success': value['success'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
    };
}

